import React from 'react';
import { Box, CircularProgress } from '@mui/material';

const LoadingSpinner = ({ message = 'Đang tải...' }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '200px',
                gap: 2,
            }}
        >
            <CircularProgress size={48} />
            {message && (
                <Box sx={{ color: 'text.secondary', fontSize: '0.95rem' }}>
                    {message}
                </Box>
            )}
        </Box>
    );
};

export default LoadingSpinner;
